import { ResourceListOfWorkflowOptionApprovalDto } from 'src/services/Client';
import { IReduxState } from '../IReduxState';

export const selectApprovals = (
  state: IReduxState
): ResourceListOfWorkflowOptionApprovalDto | undefined =>
  state.approvals.approvals;



// WEBPACK FOOTER //
// ./src/redux/selectors/approvalsSelectors.ts